import { BenLoading } from './BenLoading'
import { BenModal } from './BenModal'
import { BenQuery } from './BenQuery'
import { BenView } from './BenView'
const _st = { htmlPromise: {} }
export class BenArt {
  static async init(artDones, app) {
    const $artList = BenQuery.query('a[modal="art"]')
    $artList.forEach(async ($art) => {
      if (artDones.includes($art)) return
      artDones.push($art)
      const href = $art.getAttribute('href') || null
      if (!href) return
      let promise = _st.htmlPromise[href]
      if (!promise) {
        promise = BenQuery.ajax(href, { method: 'GET', data: { type: 'modal' } })
        _st.htmlPromise[href] = promise
      }
      const modalHtml = await promise
      $art.addEventListener('click', (e) => {
        if (href.includes('contact-us')) BenView.setAction('of')
        e.preventDefault()
        const dom = BenQuery.createElement('div', { className: 'c-art-modal' })
        dom.innerHTML = modalHtml
        BenModal.init(dom, app, { type: 'win' })
      })
    })
  }
}
